import React, { Component } from "react";
import "./ModalFinGame.scss"
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import descargable1 from "../../../assets/img/lightboxEndGame/preview_escargable_1.png"
import descargable2 from "../../../assets/img/lightboxEndGame/preview_escargable_2.png"
import descargable3 from "../../../assets/img/lightboxEndGame/preview_escargable_3.png"
import archivoDescargable1 from "../../../assets/img/lightboxEndGame/Descargable_1.png"
import archivoDescargable2 from "../../../assets/img/lightboxEndGame/Descargable_2.png"
import archivoDescargable3 from "../../../assets/img/lightboxEndGame/Descargable_3.png"


class ModalFinGame extends Component {

    render() {
        const min = 1;
        const max = 3;
        const rand = Math.floor(Math.random() * (max - min + 1) + min)
        let descargable = archivoDescargable1;
        let imgDescargable = descargable1;
        switch (rand) {
            case 1:
                descargable = archivoDescargable1;
                imgDescargable = descargable1;
                break;
            case 2:
                descargable = archivoDescargable2;
                imgDescargable = descargable2;
                break;
            case 3:
                descargable = archivoDescargable3;
                imgDescargable = descargable3;
                break;
        
            default:
                descargable = archivoDescargable1;
                imgDescargable = descargable1;
                break;
        }
        var aux: any = this.props;
        var puntos = aux.Game.puntosGame
        return (
            <div className="ModalFinGame" >
                <div className="ModalWrap">
                    <div>
                        <div className={"contentModal contentModal-" + rand}>
                            <div className="contentModal__info">
                                <p className="contentModal__title">¡FIN DE JUEGO!</p>
                                <p className="contentModal__copy1">Obtuviste</p>
                                <p className="contentModal__puntos">{puntos} </p>
                                <p className="contentModal__copy2">puntos</p>
                                <Link to="/" className="contentModal__btnjuega" >
                                        Volver jugar
                                </Link>  
                            </div>
                        </div>
                        <p className="copyDescarga"><span>Descarga</span> este mensaje y <span>compártelo</span> en redes para que todos sepan lo poderosas que somos.</p>
                    </div>
                    <div>
                        <img className="ModalWrap__imgDescarga" alt="descargable nol juego" src={imgDescargable} />
                        <a className="contentModal__btnDescarga" href={descargable} download="mensaje_al_poder_nol.png" >
                            DESCARGAR
                    </a>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ Game, Account }: any) => ({ Game, Account });
const mapDispatchToProps = (dispatch: any) => ({
    
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalFinGame);
